import MatomoMessage from '@/matomo/message/MatomoMessage';
import {
  OrderDto,
  OrderItemDto
} from '@eurogast/hub-client-typescript';
import { CartItem } from '@/services/cart/model/cart';
import { MatomoActions } from '@/matomo/MatomoActions';
import _ from 'lodash';

export default class MatomoOrderSubmit {
  private orderItems: MatomoMessage[];
  private submitOrderMessage: MatomoMessage;

  private constructor(orderItems: MatomoMessage[], submitOrderMessage: MatomoMessage) {
    this.orderItems = orderItems;
    this.submitOrderMessage = submitOrderMessage;
  }

  public static from(order: OrderDto, cartItems: CartItem[]): MatomoOrderSubmit {
    return new MatomoOrderSubmit(
      this.findOrderItemMessages(order, cartItems),
      this.toSubmitOrderMessage(order)
    );
  }

  private static findOrderItemMessages(orderDto: OrderDto, cartItems: CartItem[]): MatomoMessage[] {
    return orderDto.orderItems
      .map((el) => this.toEcommerceItemMessage(el, cartItems))
      .filter((el) => el != null);
  }

  private static toEcommerceItemMessage(orderItem: OrderItemDto, cartItems: CartItem[]): MatomoMessage | null {
    const cartItem = cartItems.find((el) => el.sku === orderItem.productSku);

    if (cartItem == null) {
      return null;
    }

    return new MatomoMessage([
      MatomoActions.addEcommerceItem,
      cartItem.sku,
      cartItem.product.name,
      cartItem.product.resolvedCategory.name,
      orderItem.price,
      orderItem.amount * orderItem.ratio
    ]);
  }

  private static toSubmitOrderMessage(orderDto: OrderDto): MatomoMessage {
    const orderTotal = _.sum(
      orderDto.orderItems.map((el) => el.mostAccurateRowTotal).filter((el) => el != null)
    );

    return new MatomoMessage([
      MatomoActions.trackEcommerceOrder,
      orderDto.id,
      orderTotal
    ]);
  }

  public publish() {
    this.orderItems.forEach((el) => el.publish());
    this.submitOrderMessage.publish();
  }
}
